var _rect, _rect2, _text, _text2, _rect3, _circle, _text3, _text4, _rect4, _circle2, _text5, _text6, _rect5, _circle3, _text7, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreRealFleetOperationsEvidenceCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 600,
    height: 300,
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore real operations evidence card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 300,
    rx: 28,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 598,
    height: 298,
    rx: 27,
    fill: "none",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 43,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 1.7
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 28,
    dy: 0
  }, "LIVE OPERATIONS"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 78,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 28,
    dy: 0
  }, "Mine access \xB7 Shift check-in"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 103,
    width: 544,
    height: 45,
    rx: 12,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 125,
    r: 6,
    fill: "#30D6A1"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 130,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 680
  }, "Driver identity")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 130,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Matched to shift")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 161,
    width: 544,
    height: 45,
    rx: 12,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 183,
    r: 6,
    fill: "#087CFF"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 188,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 680
  }, "Vehicle asset")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 188,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "FC\u20132047 linked")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 219,
    width: 544,
    height: 45,
    rx: 12,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 241,
    r: 6,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 246,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 680
  }, "Access event")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 246,
    fill: "#07152A",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Evidence complete")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreRealFleetOperationsEvidenceCard);
export default __webpack_public_path__ + "static/media/fleetcore-real-fleet-operations-evidence-card.0a13dbe7574a79ffac5c2f10bc61a8de.svg";
export { ForwardRef as ReactComponent };